















import { Component, Mixins, Prop } from "vue-property-decorator";
import { ContentContainerMixin } from "./mixins";

@Component({
  components: {
    WizardContent: () => import("./WizardContent.vue"), // 再帰的に呼ばれるコンポーネントは動的import要.(単一コンポーネントでの再帰ならname指定でも回避可能？)
  },
})
export default class WizardContentHorizontalContainer extends Mixins(ContentContainerMixin) {
  @Prop()
  scale: number;
}
